import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum CrmOfferItemTypeId {
  PERCENTAGE = 'percentage',
  FEE = 'fee',
  EVENTS = 'events',
  COUNT = 'count',
  CUSTOM = 'custom',
}

export class CrmOfferItemType extends Codebook<CrmOfferItemTypeId> {
  static readonly PERCENTAGE = new CrmOfferItemType(CrmOfferItemTypeId.PERCENTAGE, () =>
    $t('Percentage'),
  )
  static readonly FEE = new CrmOfferItemType(CrmOfferItemTypeId.FEE, () => $t('Fee'))
  static readonly EVENTS = new CrmOfferItemType(CrmOfferItemTypeId.EVENTS, () => $t('Events'))
  static readonly COUNT = new CrmOfferItemType(CrmOfferItemTypeId.COUNT, () => $t('Count'))
  static readonly CUSTOM = new CrmOfferItemType(CrmOfferItemTypeId.CUSTOM, () => $t('Custom'))

  private constructor(
    id: CrmOfferItemTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
